import axios from 'axios';
import { api, apiAuth, generateTokenStructure, requestConfig } from './index';

/**
 * Response: {
 *  token: string
 * }
 */
export const generateTempToken = async () => {
	try {
		const { data } = await api.get(`/static/generateTempToken`);
		return data;
	} catch (e) {
		throw e;
	}
};

/**
 * Request: {
 *  tel: int
 *  companyName: string
 *  fullName: string
 *  email: string
 *  comment: string
 *  employeeNumber: string
 *  hasSubside: boold
 *  companyArea: string
 *  introductionMethod: string
 * }
 */
export const companyRegister = async (params) => {
	try {
		const { token } = await generateTempToken();

		const instanceApi = axios.create(requestConfig);
		instanceApi.defaults.headers.common.Authorization = generateTokenStructure(
			token,
		);

		const { data } = await instanceApi.post(`/companyRegister/add`, params);
		return data;
	} catch (e) {
		throw e;
	}
};

export const fetchCompanyDetails = async (domain) => {
	try {
		const { data } = await api.get(`/company/details?domain=${domain}`);
		return data;
	} catch (e) {
		throw e;
	}
};

export const fetchCompanyConfig = async () => {
	try {
		const { data } = await apiAuth.get('/company/config');

		// FIXME: remember remove this
		// if (process.env.NODE_ENV !== 'production') {
		// 	data.online = false;
		// 	data.offlineText = `امکان ثبت سفارش وجود ندارد
		//   لطفا در بازه زمانی 9:30 - 10:00 مراجعه کنید`;
		// }
		return data;
	} catch (e) {
		throw e;
	}
};
